import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";
 
const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
  };
};
 
const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
};
 
// ------------------ Types ------------------
export interface WatiCredentials {
  api_endpoint: string;
  api_token: string;
  last_validated: string;
  Status: string; // e.g., "Connected"
}
 
export interface WatiSyncResult {
  status: string; // e.g., "completed"
  synced: { phone: string; status: string }[];
  "skipped/failed": { phone: string; status: string }[];
}
 
// ------------------ API Calls ------------------
 
// POST: Save & Verify WATI Credentials
export const setWatiCredentials = async (
  api_endpoint: string,
  api_token: string
): Promise<{ detail: string }> => {
  try {
    const formData = new URLSearchParams();
    formData.append("api_endpoint", api_endpoint);
    formData.append("api_token", api_token);
 
    const response = await axios.post<{ detail: string }>(
      `${API_BASE_PATH}/wati/set-credentials`,
      formData,
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
 
    toast.success(response.data.detail || "WATI credentials saved successfully");
    return response.data;
  } catch (error) {
    showAxiosError(error, "Failed to set WATI credentials");
    throw error;
  }
};
 
// GET: Fetch WATI Credentials
export const getWatiCredentials = async (): Promise<WatiCredentials> => {
  try {
    const response = await axios.get<WatiCredentials>(
      `${API_BASE_PATH}/wati/get-credentials`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    showAxiosError(error, "Failed to fetch WATI credentials");
    throw error;
  }
};
 
// POST: Sync Contacts With WATI
export const syncContactsToWati = async (): Promise<WatiSyncResult> => {
  try {
    const response = await axios.post<WatiSyncResult>(
      `${API_BASE_PATH}/sync-contacts-wati`,
      {},
      {
        headers: getAuthHeaders(),
      }
    );
 
    toast.success("Contacts synced with WATI");
    return response.data;
  } catch (error) {
    showAxiosError(error, "Failed to sync contacts with WATI");
    throw error;
  }
};
 